/**
 * GCash icon URL
 * Philippines' popular mobile payment platform
 * Source: Airwallex documentation
 * Used for payment method selection UI
 */
export const GCASH_ICON_DATA_URL =
  'https://www.airwallex.com/docs/assets/contentful/images.ctfassets.net/c3n7jozh84hr/4WAO5JJPUOrZ9jBA0Vf4tf/c3896e1a5508efa0c569bd3eaa577dad/GCash.svg';
